[
  {
    "name": "Upgraded",
    "description": "Upgraded users can create unlimited cards"
  },
  {
    "name": "Spectators",
    "description": "Spectators can view public spaces, and add cards to open spaces"
  },
  {
    "name": "Moderator",
    "description": "Moderators maintain the community <a href='https://club.kinopio.club'>forum</a> and <a href='https://discord.gg/h2sR45Nby8'>discord</a>"
  },
  {
    "name": "GuideMaker",
    "description": "Guide Makers have written helpful guides about their spaces on the Kinopio blog"
  },
  {
    "name": "Donor",
    "description": "Donors have supported the sustainable development of Kinopio through a generous donation"
  },
  {
    "name": "Ambassador",
    "description": "<a href='https://kinopio.club/friends-of-kinopio-ambassadors-YNmS6C3fofN3R9mYgO1Bu'>Friends of Kinopio</a> that share how they use Kinopio with the world"
  }
]